import './Header.scss';
import Logo from './pinpoint-logo.svg';

import React from 'react';

import H1 from 'components/H1';
import PageTitle from './PageTitle';
import UserMenu from 'components/UserMenu';

export default class Header extends React.Component {
    static propTypes = {
        isTestingAuth: React.PropTypes.bool.isRequired,
        title: React.PropTypes.string.isRequired,
        user: React.PropTypes.object.isRequired
    };

    render() {
        let { isTestingAuth, title, user } = this.props;
        return (
            <header className="body__header">
                <button id="openCloseMenu"
                        className="open-close-menu"
                        onClick={() => { document.body.classList.toggle('open-menu')}}>
                    <div className="open-close-menu_inner">
                        <div className="menu-line line1"></div>
                        <div className="menu-line line2">
                            <div className="menu-line line4"></div>
                        </div>
                        <div className="menu-line line3"></div>
                    </div>
                </button>
                <H1>
                    <img src={Logo} alt="PinPoint" />
                    <PageTitle>
                        {title}
                    </PageTitle>
                </H1>
                {isTestingAuth === true ? null : <UserMenu user={user} />}
            </header>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Header/index.js